import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=52b155f1&scoped=true&"
import script from "./programme.vue?vue&type=script&lang=js&"
export * from "./programme.vue?vue&type=script&lang=js&"
import style0 from "./programme.vue?vue&type=style&index=0&id=52b155f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b155f1",
  null
  
)

export default component.exports